{
	"receivedValue": "Total value granted",
	"spentValue": "Products paid with bonus",
	"tipValue": "Service paid with bonus",
	"spentInOtherEvent": "Sales paid with bonus in another period",
	"spentTipValueInOtherEvent": "Service paid with bonus in another period",
	"receivedValueTooltip": "Total bonuses granted in the filtered period",
	"spentValueTooltip": "Total products paid with bonus in the filtered period",
	"tipValueTooltip": "Total services paid with bonus in the filtered period",
	"spentInOtherEventTooltip": "Total bonuses granted in the filtered period and used in a different period, not considering service",
	"spentTipValueInOtherEventTooltip": "Total services paid with bonus granted in the filtered period and used in a different period"
}
